export default async function initReadAloudPlayer() {
  const element = document.querySelector('[data-js-module="read-aloud-player"]');

  if (element) {
    const { default: ReadAloudPlayer } = await import(/* webpackChunkName: "read-aloud-player" */ './read-aloud-player');
    new ReadAloudPlayer(element);
  }
}
